import React from "react";
import moment from "moment";
import {
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LineChart,
  Tooltip,
  ReferenceLine,
} from "recharts";

function StockChart({ data, releaseDate }) {
  const minValue = Math.min(...data.map((data) => data.value));
  const uniqueMonths = [
    ...new Map(
      data.map((item) => [moment(item.date).format("YYYY-MM"), item.date])
    ).values(),
  ];

  return (
    <div className="stock-chart-container">
      <ResponsiveContainer width={"100%"} height="100%">
        <LineChart
          data={data}
          margin={{ top: -10, right: 20, left: 0, bottom: 10 }}
        >
          <XAxis
            dataKey="date"
            tickFormatter={(value) => moment(value)?.format("MMM YY")}
            ticks={uniqueMonths}
          />
          <YAxis
            domain={["dataMin - 10", "dataMax + 10"]}
            allowDecimals={false}
            tickFormatter={(value) =>
              value === minValue - 10 ? "" : `$${Math.round(value)}`
            }
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke="#05bf02"
            strokeWidth={3}
            dot={{ r: 0 }}
          />
          {/* <Tooltip /> */}
          {/* <ReferenceLine x={releaseDate} stroke="#666" strokeDasharray="3 3" /> */}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default StockChart;
